import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Button } from '@optimus-web/core';

export const CancelButton = ({ isCancelled, handleCancel }: CancelButtonProps) =>
    isCancelled ? (
        <LocalizedText textKey={TextKey.Canceled} />
    ) : (
        <Button onClick={handleCancel} data-test-cancel-button type="submit">
            <LocalizedText textKey={TextKey.Cancel} />
        </Button>
    );

interface CancelButtonProps {
    isCancelled: boolean;
    handleCancel: (event: React.SyntheticEvent) => void;
}
